{
  "ancillaries": {
    "toaster": {
      "errorSavingPriority": "Tekemiäsi muutoksia priority-palveluihin ei pystytty tallentamaan. Ole hyvä ja yritä uudelleen."
    },
    "priority": {
      "extraTitle": "Priority-palvelut",
      "select": "Lisää",
      "selected": "Lisätty",
      "eligibility": {
        "notAvailableBus": "Valitettavasti <b>matkasi tälle osuudelle ei voi ostaa priority-palveluita verkkosivuiltamme</b>, koska tämä on bussiyhteys.",
        "notAvailableTrain": "Valitettavasti <b>matkasi tälle osuudelle ei voi ostaa priority-palveluita verkkosivuiltamme</b>, koska tämä on junayhteys."
      },
      "noPriorityAvailable": "Priority-palvelut ei ole saatavilla matkasi tälle osuudelle.",
      "inCart": "Lisätty ostoskoriin",
      "paid": "Vahvistettu",
      "alreadyPurchased": "Tälle matkustajalle on jo ostettu priority-palvelut.",
      "additionalInfoBlockNotificationHel": "Huomaa, että lapsiperheet voivat käyttää Helsinki-Vantaan lentoaseman erillistä turvatarkastusväylää <b>maksutta</b>. Jos tämä koskee sinua, tätä palvelua ei tarvitse ostaa meiltä."
    }
  },
  "services": {
    "priority": {
      "maxedPurchasesNotification": "Olet lisännyt enimmäismäärän priority-palveluita tälle matkalle.",
      "noQuotaLeft": "Kaikki saatavilla olevat priority-palvelut on jo varattu tälle osuudelle matkaa.",
      "title": "Priority-palvelut",
      "state": {
        "updating": {
          "ariaText": "Vahvistetaan priority-palvelut -valintaa"
        },
        "purchased": {
          "default": "Priority-palvelut ei ole vielä vahvistettu",
          "plural": "{numberOfItems} x Priority-palvelut vahvistettu",
          "singular": "1 x Priority-palvelut vahvistettu"
        },
        "selection": {
          "default": "Ei vielä valittuja priority-palveluita",
          "plural": "{numberOfItems} Priority-palvelut odottaa ostoskorissa",
          "singular": "1 Priority-palvelut odottaa ostoskorissa"
        },
        "select": {
          "ariaText": "Osta priority-palvelut",
          "text": "Valitse"
        },
        "modify": {
          "ariaText": "Muokkaa priority-palvelut -valintaa",
          "text": "Muokkaa"
        }
      }
    }
  }
}
